<section class="section-calendar">
  <div class="container-select-hour">
    <h3 class="input-title-blue">{{"SelectHour" |translate}}</h3>
    <div class="content-btn-hour">
      <div class="btn-hour-for" *ngFor="let timehour of timeListButtons  let index = index">
        <button
          mat-raised-button
         
          [ngClass]="timehour.class"
          (click)="timeValue(timehour,index)"
          name="timeButton"
        >
          {{ timehour.hours }}
        </button>
      </div>
    </div>
  </div>
  <div class="container-calendar" >
    <h3 class="input-title-blue">{{"SelectDate" |translate}}</h3>
    <mat-card class="demo-inline-calendar-card">
      <mat-calendar
      
        [(selected)]="calendarTime"
        class="calendar"
        (click)="SelectDateDinamic()"
        [dateFilter]="dateFilter"
      ></mat-calendar>
    </mat-card>
  </div>
</section>
<div></div>
